const getAddressComponent = (components, types) => {
  const component = components.find((c) =>
    types.some((type) => c.types.includes(type))
  );
  return component ? component.long_name : '';
};

export const mapGooglePlaceToFields = (place, fieldPrefix = '') => {
  const components = place.address_components || [];

  const streetNumber = getAddressComponent(components, ['street_number']);
  const route = getAddressComponent(components, ['route']);
  const subpremise = getAddressComponent(components, ['subpremise']);
  const premise = getAddressComponent(components, ['premise']);
  const sublocality = getAddressComponent(components, [
    'sublocality',
    'neighborhood',
    'sublocality_level_1',
    'sublocality_level_2',
  ]);
  const locality = getAddressComponent(components, ['locality']);
  const postalTown = getAddressComponent(components, ['postal_town']);
  const county = getAddressComponent(components, ['administrative_area_level_2']);
  const postcode = getAddressComponent(components, ['postal_code']);

  const streetParts = [subpremise, premise, streetNumber, route].filter(Boolean);
  const addressLine1 = streetParts.join(' ').trim() || '';

  const cityTown = postalTown || locality || '';

  // Use locality for line 2 only when it differs from postal_town
  let addressLine2 = sublocality;
  if (!addressLine2 && locality && postalTown && locality !== postalTown) {
    addressLine2 = locality;
  }

  const distinctCounty = county && county !== cityTown ? county : '';
  const lines = [addressLine1, addressLine2, cityTown, distinctCounty].map((line) => line || '');

  const prefix = fieldPrefix ? `${fieldPrefix}AddressLine` : 'addressLine';
  const postcodeField = fieldPrefix ? `${fieldPrefix}Postcode` : 'homePostcode';

  return {
    [`${prefix}1`]: lines[0],
    [`${prefix}2`]: lines[1],
    [`${prefix}3`]: lines[2],
    [`${prefix}4`]: lines[3],
    [postcodeField]: postcode,
  };
};

export default mapGooglePlaceToFields;

export const mapLoqateToFields = (address, fieldPrefix = '') => {
  const prefix = fieldPrefix ? `${fieldPrefix}AddressLine` : 'addressLine';
  const postcodeField = fieldPrefix ? `${fieldPrefix}Postcode` : 'homePostcode';

  return {
    [`${prefix}1`]: address.line1 || '',
    [`${prefix}2`]: address.line2 || '',
    [`${prefix}3`]: address.city || '',
    [`${prefix}4`]: address.province || '',
    [postcodeField]: address.postalCode || '',
  };
};
